<template>
  <div class="equipment">
    <div class="equipment-top">
      <span class="top-left">
        设备监控
      </span>
      <div class="top-right">
        <el-select v-model="provincesName" clearable placeholder="请选择" @change="getCity(provincesName)">
          <el-option
            v-for="item in provincesList"
            :key="item.province"
            :label="item.province"
            :value="item.province">
          </el-option>
        </el-select>
        <el-select v-model="cityName" clearable placeholder="请选择" @change="getStations(cityName)">
          <el-option
            v-for="item in cityList"
            :key="item.city"
            :label="item.city"
            :value="item.city">
          </el-option>
        </el-select>
        <el-select v-model="stationName" clearable placeholder="请选择场站" @change="((val)=>{stationChange(val, 1)})">
          <el-option
            v-for="item in stationList"
            :key="item.station_id"
            :label="item.station_name"
            :value="item.station_id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="equipment-center">
      <a href="javascript:void(0);" :class="[activeS==0?'activeS':'']" @click="countClick('total',0)">
        <i class="circular1"></i>
        <span>总枪</span>
        <span>{{chargerGunCount.total | defaultValFilterNum}}</span>
      </a>
      <a href="javascript:void(0);" :class="[activeS==1?'activeS':'']" @click="countClick('charging',2)">
        <i class="circular2"></i>
        <span>充电中</span>
        <span>{{chargerGunCount.charging | defaultValFilterNum}}</span>
      </a>
      <a href="javascript:void(0);" :class="[activeS==2?'activeS':'']" @click="countClick('free',1)">
        <i class="circular3"></i>
        <span>空闲</span>
        <span>{{chargerGunCount.free | defaultValFilterNum}}</span>
      </a>
      <a href="javascript:void(0);" :class="[activeS==3?'activeS':'']" @click="countClick('offline',3)">
        <i class="circular4"></i>
        <span>离线</span>
        <span>{{chargerGunCount.offline | defaultValFilterNum}}</span>
      </a>
      <a href="javascript:void(0);" :class="[activeS==4?'activeS':'']" @click="countClick('fault',4)">
        <i class="circular5"></i>
        <span>故障</span>
        <span>{{chargerGunCount.fault | defaultValFilterNum}}</span>
      </a>
      <a href="javascript:void(0);" :class="[activeS==5?'activeS':'']" @click="countClick('appoint',5)">
        <i class="circular6"></i>
        <span>预约</span>
        <span>{{chargerGunCount.appoint | defaultValFilterNum}}</span>
      </a>
      <a href="javascript:void(0);" :class="[activeS==6?'activeS':'']" @click="countClick('uncharging',6)">
        <i class="circular7"></i>
        <span>就绪</span>
        <span>{{chargerGunCount.uncharging | defaultValFilterNum}}</span>
      </a>
    </div>
    <div class="equipment-bottom">
      <div class="bottom-content" v-for="(item,index) in deviceList" :key="index">
        <div class="box-top" :class="{'box-free': item.status == 1,'box-offline': item.status == 3,'box-fault': item.status == 4,'box-appointment': item.status == 5,'box-ready': item.status == 6}">
          <div class="title">
            <span class="issue-number">{{ item.charger_id }}</span>
            <span class="gun-number">{{ item.gun_no }}枪</span>
            <span class="slash">/</span>
            <span class="state" v-if="item.status==1">空闲</span>
            <span class="state" v-if="item.status==2">充电中</span>
            <span class="state" v-if="item.status==3">离线</span>
            <span class="state" v-if="item.status==4">故障</span>
            <span class="state" v-if="item.status==5">预约</span>
            <span class="state" v-if="item.status==6">就绪</span>
          </div>
          <div class="icon"></div>
        </div>
        <div class="box-bottom" id="box-bottom" :class="[item.active==true?'active':'']">
          <div class="logo-icon" :class="{'free': item.status == 1,'charge': item.status == 2,'outline': item.status == 3,'fault': item.status == 4,'yuy': item.status == 5,'ready': item.status == 6}"></div>
          <div class="details" v-if="item.status==2">
            <ul :class="[item.ulActive==true?'active':'']">
              <li>
                <div>
                  <i class="qty-now"></i>
                  <span class="name" :class="[item.nameA==true?'active':'']">已充电量</span>
                  <span class="data">{{item.qty_now | defaultValFilter}}kwh</span>
                </div>
              </li>
              <li>
                <div>
                  <i class="chargin-time"></i>
                  <span class="name" :class="[item.nameA==true?'active':'']">已充时长</span>
                  <span class="data">{{item.chargin_time | defaultValFilter}}</span>
                </div>
              </li>
              <li>
                <div>
                  <i class="elce-fee"></i>
                  <span class="name" :class="[item.nameA==true?'active':'']">已充金额</span>
                  <span class="data">{{item.elce_fee | defaultValFilter}}元</span>
                </div>
              </li>
              <li>
                <div>
                  <i class="soc"></i>
                  <span class="name" :class="[item.nameA==true?'active':'']">SOC</span>
                  <span class="data">{{item.soc | defaultValFilter}}%</span>
                </div>
              </li>
              <li>
                <div>
                  <i class="current"></i>
                  <span class="name" :class="[item.nameA==true?'active':'']">电流</span>
                  <span class="data">{{item.current | defaultValFilter}}A</span>
                </div>
              </li>
              <li>
                <div>
                  <i class="voltage"></i>
                  <span class="name" :class="[item.nameA==true?'active':'']">电压</span>
                  <span class="data">{{item.voltage | defaultValFilter}}V</span>
                </div>
              </li>
              <li>
                <div>
                  <i class="vin"></i>
                  <span class="name" :class="[item.nameA==true?'active':'']">VIN</span>
                  <span class="data data-vin">{{item.vin | defaultValFilter}}</span>
                </div>
              </li>
            </ul>
          </div>
          <div class="details free" v-if="item.status==1">
            <ul>
              <li>
                <div>
                  <i class="lasttime-date"></i>
                  <span class="date">上次充电日期</span><br/>
                  <i class="lasttime-no"></i>
                  <span class="date-detail">{{item.date | defaultValFilter}}</span>
                </div>
              </li>
              <li>
                <div>
                  <i class="icon-complete"></i>
                  <span class="date">上次充电完成时间</span><br/>
                  <i class="lasttime-no lasttime-1366"></i>
                  <span class="date-detail date-1366">{{item.timestamp | defaultValFilter}}</span>
                </div>
              </li>
            </ul>
          </div>
          <div class="details free" v-if="item.status==3">
            <ul>
              <li>
                <div>
                  <i class="lasttime-date"></i>
                  <span class="date">离线日期</span><br/>
                  <i class="lasttime-no"></i>
                  <span class="date-detail">{{item.date | defaultValFilter}}</span>
                </div>
              </li>
              <li>
                <div>
                  <i class="icon-complete"></i>
                  <span class="date">离线时间</span><br/>
                  <i class="lasttime-no"></i>
                  <span class="date-detail">{{item.timestamp | defaultValFilter}}</span>
                </div>
              </li>
            </ul>
          </div>
          <div class="details fault" v-if="item.status==4">
            <ul>
              <li>
                <div>
                  <i class="fault-date"></i>
                  <span class="date-detail">{{item.timestamp | defaultValFilter}}</span>
                </div>
              </li>
              <li>
                <div>
                  <i class="icon-fault"></i>
                  <span class="date-detail date-detail-fault">{{item.remark | defaultValFilter}}</span>
                </div>
              </li>
            </ul>
          </div>
          <div class="details yuyue" v-if="item.status==5">
            <ul>
              <li>
                <div>
                  <i class="lasttime-date"></i>
                  <span class="date">预约人昵称</span><br/>
                  <i class="lasttime-no"></i>
                  <span class="date-detail">{{item.nickname | defaultValFilter}}</span>
                </div>
              </li>
              <li>
                <div>
                  <i class="icon-complete"></i>
                  <span class="date">预约到期时间</span><br/>
                  <i class="lasttime-no"></i>
                  <span class="date-detail">{{item.expired_time | defaultValFilter}}</span>
                </div>
              </li>
            </ul>
          </div>
          <div class="details ready" v-if="item.status==6">
            <ul>
              <li>
                <div>
                  <i class="lasttime-date"></i>
                  <span class="date">就绪日期</span><br/>
                  <i class="lasttime-no"></i>
                  <span class="date-detail">{{item.date | defaultValFilter}}</span>
                </div>
              </li>
              <li>
                <div>
                  <i class="icon-complete"></i>
                  <span class="date">就绪时间</span><br/>
                  <i class="lasttime-no"></i>
                  <span class="date-detail">{{item.timestamp | defaultValFilter}}</span>
                </div>
              </li>
            </ul>
          </div>
          <i class="drop-down-icon" v-if="item.status==2" :class="[item.ulActive==true?'active':'']" @click="dropClick(index)"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debug } from 'util';
export default {
  data () {
    return {
      active:false,
      nameA:false,
      open:false,
      ulActive:false,
      dropActive:false,
      options: [],
      value: '',
      list:[
        {
          name:"已充电量",
          data:"55.5kwh",
        },
        {
          name:"已充时长",
          data:"01:60:00",
        },
        {
          name:"已充金额",
          data:"10元",
        },
        {
          name:"SOC",
          data:"0%",
        },
        {
          name:"电流",
          data:"0V",
        },
        {
          name:"电压",
          data:"0A",
        },
        {
          name:"VIA",
          data:"无档案",
        },
      ],
      provincesName:"",
      provincesList:[],
      cityList:[],
      cityName:"",
      stationList:[],
      stationName:"",
      chargerGunCount:{
        free:"",//空闲枪数量
        charging:"",//充电中的枪数量
        fault:"",//	故障枪数量
        appoint:"",//	预约枪数量
        offline:"",//	离线枪数量
        uncharging:"",//就绪状态枪数量
        total:"",//	总枪口数量
      },
      defaultActive:false,
      activeNum:0,
      deviceList:[],
      defaultStationId:"",
      activeS:0,
      stationId:"",
      index:"",
      stationNumber:0,
    }
  },
  mounted(){
    document.getElementsByTagName("body")[0].className="equipment-body";
    this.$nextTick(function() {
      this.defaultActive = false;
      this.getProvinces();
      this.provincesName = this.$store.state.emProvinces;
      this.cityName = this.$store.state.emCity;
      this.stationId = this.$store.state.emStation;
     
      this.timer = setInterval(() => {
          this.countClick(localStorage.getItem("str"),localStorage.getItem("status"))
      }, 10000);
    });
  },
  watch:{
    timeChange(){
    },
  },
  beforeDestroy(){
    document.body.removeAttribute("class","equipment-body");
    clearInterval(this.timer);
  },
  methods: {
    dropClick(index){
      this.activeNum++;
      this.index = index;
      this.open = !this.open;
      this.dropActive = !this.dropActive;
      for(let i in this.deviceList){
        if(i==index){
          this.deviceList[i].active = !this.deviceList[i].active;
          this.deviceList[i].ulActive = !this.deviceList[i].ulActive;
          this.deviceList[i].nameA = !this.deviceList[i].nameA;
        }
      }
      this.$forceUpdate();
    },
    getProvinces(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_provinces",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.provincesList = su.data.list;
            this.provincesName = this.$store.state.emProvinces?this.$store.state.emProvinces:this.provincesList[0].province;
            this.getCity2(this.$store.state.emProvinces?this.$store.state.emProvinces:this.provincesList[0].province);
            // this.provincesName = this.provincesList[0].province;
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    getCity(province){
      this.stationList=[]
      this.cityName = "";
      this.stationName = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province:province,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.cityList = su.data.list;
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    getCity2(province){
      // this.cityName = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province:province,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.cityList = su.data.list;
            this.cityName = this.$store.state.emCity?this.$store.state.emCity:this.cityList[0].city;
            // this.stationId = this.$store.state.emStation;
            if(this.cityName == "信阳"){
              this.cityName = "信阳市";
            }
            if(this.$store.state.emCity == "信阳"){
              this.$store.state.emCity = "信阳市";
            }
            this.getStations2(this.$store.state.emCity?this.$store.state.emCity:this.cityList[0].city);
            // this.cityName = this.cityList[0].city;
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    getStations(city){
      this.stationName = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city:city,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.stationList = su.data.list;
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    getStations2(city){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city:city,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.stationList = su.data.list;
            this.stationName = this.$store.state.emStation?this.$store.state.emStation:this.stationList[0].station_name;
            this.stationId = this.$store.state.emStation?this.$store.state.emStation:this.stationList[0].station_id;
            this.getChargerGunCount2(this.$store.state.emStation?this.$store.state.emStation:this.stationList[0].station_id);
            this.getDeviceList2(this.$store.state.emStation?this.$store.state.emStation:this.stationList[0].station_id);
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    stationChange(data,num){
      this.stationId = data;
      this.getChargerGunCount(this.stationId);
      this.getDeviceList(this.stationId);
      this.activeS = 0;
      this.stationNumber = num;
      this.$store.commit("changeEmProvinces",this.provincesName);
      this.$store.commit("changeEmCity",this.cityName);
      this.$store.commit("changeEmStation",this.stationId);
    },
    getChargerGunCount(data){
      // debugger
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"getChargerGunCount",
        station_id: data,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceMonitor/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.chargerGunCount = su.data.list;
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    getChargerGunCount2(data){
      // debugger
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"getChargerGunCount",
        station_id: data,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceMonitor/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.chargerGunCount = su.data.list;
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    getDeviceList(data){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"getDeviceList",
        station_id: data?data:this.defaultStationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceMonitor/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.deviceList = su.data.list;
            let classVal = document.getElementById('box-bottom').getAttribute("class");
            if(this.stationNumber == 1){
              for(let i in this.deviceList){
                if(this.index == i){
                  if(this.deviceList[i].status==2){
                    this.deviceList[i].active=false;
                    this.deviceList[i].ulActive=false;
                    this.deviceList[i].nameA=false;
                  } else {
                    classVal = classVal.removeAttribute('active',"");
                  }
                }
              }
              this.index = "";
              this.activeNum = "";
            } else if(this.stationNumber == 2) {
              for(let i in this.deviceList){
                if(this.index == i){
                  if(this.deviceList[i].status==2){
                    if(this.activeNum%2==1){
                      this.deviceList[i].active=true;
                      this.deviceList[i].ulActive=true;
                      this.deviceList[i].nameA=true;
                    } else {
                      this.deviceList[i].active=false;
                      this.deviceList[i].ulActive=false;
                      this.deviceList[i].nameA=false;
                    }
                  } else {
                    classVal = classVal.removeAttribute('active',"");
                  }
                }
              }
            }
            // console.log(this.stationNumber);
            // console.log(this.index);
            // console.log(this.activeNum);
            
            // console.log(22);
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == -1) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
              } else {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    getDeviceList2(data){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"getDeviceList",
        station_id: data,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceMonitor/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.deviceList = su.data.list;
            // this.deviceList.push(
            //   {
            //     "charger_id":"10010721",//	充电桩编号
            //     "gun_no":"1",//枪号
            //     "status":"2",//充电中
            //     "qty_now":"55.5",//已充电量
            //     "chargin_time":"01:60:00",//已充时间
            //     "elce_fee":"10",//已充金额
            //     "voltage":"0",//电压
            //     "current":"0",//电流
            //     "soc":"0",//电池剩余电量
            //     "vin":"无档案"//车辆VIN码
            //   },
            //   {
            //     "charger_id":"10010721",//	充电桩编号
            //     "gun_no":"1",//枪号
            //     "status":"2",//充电中
            //     "qty_now":"55.5",//已充电量
            //     "chargin_time":"01:60:00",//已充时间
            //     "elce_fee":"10",//已充金额
            //     "voltage":"0",//电压
            //     "current":"0",//电流
            //     "soc":"0",//电池剩余电量
            //     "vin":"无档案"//车辆VIN码
            //   },
            // );
            for(let i in this.deviceList){
              if(this.deviceList[i].status==2){
                this.deviceList[i].active=false;
                this.deviceList[i].ulActive=false;
                this.deviceList[i].nameA=false;
              }
            }
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == -1) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
              } else {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    getDeviceListByStatus(station_id,status){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"getDeviceListByStatus",
        station_id: this.stationId?this.stationId:"HNXYJXBG",
        status:status,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceMonitor/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.deviceList = su.data.list;
            // debugger
            for(let i in this.deviceList){
              this.deviceList[i].status = status;
              
              if(this.deviceList[i].status==2){
                this.deviceList[i].active=false;
                this.deviceList[i].ulActive=false;
                this.deviceList[i].nameA=false;
              }
            }
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == -1) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
              } else {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    countClick(str,status){
      localStorage.setItem("str",str)
      localStorage.setItem("status",status)
      if(str == 'total'){
        this.activeS = 0;
        this.getDeviceList(this.stationId);
      } else if(str == 'charging'){
        this.activeS = 1;
        this.getDeviceListByStatus(this.stationId,status);
      } else if(str == 'free'){
        this.activeS = 2;
        this.getDeviceListByStatus(this.stationId,status);
      } else if(str == 'offline'){
        this.activeS = 3;
        this.getDeviceListByStatus(this.stationId,status);
      } else if(str == 'fault'){
        this.activeS = 4;
        this.getDeviceListByStatus(this.stationId,status);
      } else if(str == 'appoint'){
        this.activeS = 5;
        this.getDeviceListByStatus(this.stationId,status);
      } else if(str == 'uncharging'){
        this.activeS = 6;
        this.getDeviceListByStatus(this.stationId,status);
      }
      
    }
  }
}

</script>

<style scoped lang="scss">
.equipment {
  -moz-user-select: none; 
  -webkit-user-select: none; 
  -ms-user-select: none; 
  -khtml-user-select: none; 
  -o-user-select:none;
  user-select: none;
  .equipment-top {
    width: 98%;
    margin-left: 1%;
    height: 62px;
    background-color: #0C202B;
    margin-top: 18px;
    // display: flex;
    // align-items: center;
    .top-left {
      color: #FEFFFF;
      float: left;
      line-height: 62px;
      margin-left: 20px;
    }
    .top-right {
      float: right;
      margin-right: 20px;
      margin-top: 11px;
    }
  }
  .equipment-center {
    width: 100%;
    height: 80px;
    line-height: 80px;
    a {
      display: inline-block;
      text-decoration:none;
      color: #727C7E;
      margin-right: 30px;
      i {
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #0079c0;
        margin-right: 5px;
      }
      .circular2 {
        background-color: #0078c1;
      }
      .circular3 {
        background-color: #01B16F;
      }
      .circular4 {
        background-color: #9B9B9B;
      }
      .circular5 {
        background-color: #FDA711;
      }
      .circular6 {
        background-color: #F95945;
      }
      .circular7 {
        background-color: #FF29E8;
      }
      span {

      }
    }
    a:last-child {
      margin-right: 0px;
    }
    a.activeS {
      color: #FFFFFF;
    }
  }
  .equipment-bottom {
    width: 98%;
    margin-left: 1%;
    // background-color: #fff;
    .bottom-content {
      display: inline-block;
      // width: 23.7%;
      width: 24.25%;
      height: 220px;
      // background-color: #ccc;
      float: left;
      margin-right:1%;
      margin-bottom: 18px;
      vertical-align: top;
      -webkit-transition: .3s ;
      -o-transition: .3s ;
      transition: .3s ;
      .box-top {
        width: 100%;
        height: 50px;
        background-color: #0078BF;
        .title {
          float: left;
          line-height: 50px;
          span {
            color: #FEFFFF;
          }
          .issue-number {
            margin-left: 18px;
          }
        }
        .icon {
          width: 15px;
          height: 14px;
          background: url(../../assets/img/shebei-icon.png) -2px -130px no-repeat;
          float: right;
          margin-top: 18px;
          margin-right: 18px;
        }
      }
      .box-top.box-free {
        background-color: #02B36F;
      }
      .box-top.box-offline {
        background-color: #9C9C9C;
      }
      .box-top.box-fault {
        background-color: #FFA801;
      }
      .box-top.box-appointment {
        background-color: #FC5A45;
      }
      .box-top.box-ready {
        background-color: #FF26E7;
      }
      .box-bottom {
        background-color: #122430;
        height: 170px;
        position: relative;
        -webkit-transition: .3s ;
        -o-transition: .3s ;
        transition: .3s ;
        position: relative;
        .logo-icon {
          display: inline-block;
          vertical-align: top;
          width: 60px;
          height: 74px;
          // margin-top: 30px;
          // margin-left: 50px;
          // float: left;
          position: absolute;
          top: 30px;
          left: 50px;
        }
        .logo-icon.charge {
          background: url(../../assets/img/shebei-icon.png) 0px 0px no-repeat;
        }
        .logo-icon.free {
          background: url(../../assets/img/shebei-icon.png) -80px 0px no-repeat;
        }
        .logo-icon.outline {
          background: url(../../assets/img/shebei-icon.png) -160px 0px no-repeat;
        }
        .logo-icon.fault {
          background: url(../../assets/img/shebei-icon.png) -240px 0px no-repeat;
        }
        .logo-icon.yuy {
          background: url(../../assets/img/shebei-icon.png) -320px 0px no-repeat;
        }
        .logo-icon.ready {
          background: url(../../assets/img/shebei-icon.png) -400px 0px no-repeat;
        }
        .details {
          width: 54%;
          // float: right;
          display: inline-block;
          vertical-align: top;
          height: 100%;
          // margin-top: 26px;
          // margin-left: 12%;
          position: absolute;
          top: 26px;
          right: 1%;
          ul {
            list-style: none;
            height: 102px;
            overflow: hidden;
            li {
              width: 100%;
              height: 34px;
              text-align: left;
              i {
                // display: inline-block;
                width: 12px;
                height: 19px;
                // background-color: #fff;
                float: left;
                margin-right: 17px;
              }
              i.qty-now {
                background: url(../../assets/img/shebei-icon.png) 0px -99px no-repeat;
                margin-left: 2px;
                margin-right: 19px;
              }
              i.chargin-time {
                width: 17px;
                height: 17px;
                background: url(../../assets/img/shebei-icon.png) -32px -100px no-repeat;
              }
              i.elce-fee {
                width: 17px;
                height: 17px;
                background: url(../../assets/img/shebei-icon.png) -69px -100px no-repeat;
              }
              i.soc {
                width: 15px;
                height: 18px;
                background: url(../../assets/img/shebei-icon.png) -106px -100px no-repeat;
              }
              i.current {
                width: 17px;
                height: 17px;
                background: url(../../assets/img/shebei-icon.png) -141px -100px no-repeat;
              }
              i.voltage {
                width: 17px;
                height: 17px;
                background: url(../../assets/img/shebei-icon.png) -178px -100px no-repeat;
              }
              i.vin {
                width: 19px;
                height: 13px;
                background: url(../../assets/img/shebei-icon.png) -215px -100px no-repeat;
                margin-top: 2px;
              }
              span {
                color: #60C8FF;
                margin-right: 17px;
              }
              .name {
                display: none;
              }
              .name.active {
                display: inline-block;
                -webkit-transition: .3s ;
                -o-transition: .3s ;
                transition: .3s ;
              }
              .data {
              }
              .data-vin {
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 12px;
              }
            }
            li.activeL {
              display: none;
            }
          }
          ul.active {
            height: 238px;
            overflow: hidden;
          }
        }
        .details.free {
          ul {
            height: 135px;
            li {
              height: 64px;
              .lasttime-date {
                width: 17px;
                height: 17px;
                float: left;
                margin-right: 17px;
                margin-top: 2px;
                background: url(../../assets/img/shebei-icon.png) -254px -100px no-repeat;
              }
              .lasttime-no {
                width: 17px;
                height: 17px;
                float: left;
                margin-right: 17px;
              }
              .date-detail {
                display: inline-block;
                margin-top: 12px;
                width: 70%;
              }
              .icon-complete {
                width: 17px;
                height: 17px;
                background: url(../../assets/img/shebei-icon.png) -32px -100px no-repeat;
              }
            }
          }
        }
        .details.fault {
          ul {
            height: 125px;
            li {
              height: 36px;
              div {
                .fault-date {
                  width: 17px;
                  height: 17px;
                  float: left;
                  margin-right: 17px;
                  margin-top: 2px;
                  background: url(../../assets/img/shebei-icon.png) -32px -100px no-repeat;
                }
                .lasttime-no {
                  width: 17px;
                  height: 17px;
                  float: left;
                  margin-right: 17px;
                }
                .date-detail {
                  display: inline-block;
                  margin-top: 3px;
                  width: 70%;
                }
                .date-detail-fault {
                  width: 70%;
                  height: 100%;
                  line-height: 26px;
                }
                .icon-fault {
                  width: 20px;
                  height: 17px;
                  background: url(../../assets/img/shebei-icon.png) -291px -100px no-repeat;
                  margin-top: 5px;
                }
              }
            }
          }
        }
        .details.yuyue {
          ul {
            height: 125px;
            li {
              height: 64px;
              .lasttime-date {
                width: 15px;
                height: 17px;
                float: left;
                margin-right: 17px;
                margin-top: 2px;
                background: url(../../assets/img/shebei-icon.png) -331px -100px no-repeat;
                
              }
              .lasttime-no {
                width: 17px;
                height: 17px;
                float: left;
                margin-right: 17px;
              }
              .date-detail {
                display: inline-block;
                margin-top: 8px;
                width: 70%;
              }
              .icon-complete {
                width: 17px;
                height: 17px;
                background: url(../../assets/img/shebei-icon.png) -254px -100px no-repeat;
              }
            }
          }
        }
        .details.ready {
          ul {
            height: 125px;
            li {
              height: 64px;
              .lasttime-date {
                width: 17px;
                height: 17px;
                float: left;
                margin-right: 17px;
                margin-top: 2px;
                background: url(../../assets/img/shebei-icon.png) -254px -100px no-repeat;
              }
              .lasttime-no {
                width: 17px;
                height: 17px;
                float: left;
                margin-right: 17px;
              }
              .date-detail {
                display: inline-block;
                margin-top: 12px;
              }
              .icon-complete {
                width: 17px;
                height: 17px;
                background: url(../../assets/img/shebei-icon.png) -32px -100px no-repeat;
              }
            }
          }
        }
        .drop-down-icon {
          display: inline-block;
          cursor: pointer;
          width: 13px;
          height: 8px;
          background: url(../../assets/img/icon2.png) -236px -91px no-repeat;
          position: absolute;
          left: 48%;
          bottom: 10px;
        }
        .drop-down-icon.active {
          -webkit-transform: rotate(180deg);
          -moz-transform: rotate(180deg);
          -o-transform: rotate(180deg);
          -ms-transform: rotate(180deg);
          transform: rotate(180deg);
          -webkit-transition: .3s ;
          -o-transition: .3s ;
          transition: .3s ;
        } 
      }
      .box-bottom.active {
        height: 300px;
        z-index: 100;
        box-shadow:0px 3px 0px rgba(0,0,0,.15);
        -webkit-transition: .3s ;
        -o-transition: .3s ;
        transition: .3s ;
      }
    }
    .bottom-content:nth-child(4n+4) {
      margin-right: 0px;
    }
    .bottom-content.active {
      height: 350px;
      -webkit-transition: .3s ;
      -o-transition: .3s ;
      transition: .3s ;
    }
  }
}
@media screen and (min-width:1265px) and (max-width:1650px){
  .equipment {
    .box-top {
      .title {
        span {
          font-size: 14px !important; 
        }
        .issue-number {
          margin-left: 10px !important; 
        }
      }
      .icon {
        margin-right: 10px !important; 
      }
    }
    .box-bottom {
      height: 156px !important;
      .logo-icon {
        // margin-left: 35px !important;
      }
      .details {
        ul {
          li {
            i.qty-now {
              margin-right: 10px !important;
            }
            i.chargin-time,i.elce-fee,i.current,i.voltage {
              margin-right: 8px !important;
            }
            i.soc,i.vin {
              margin-right: 10px !important;
            }
            span {
              font-size: 14px;
              margin-right: 5px !important;
            }
          }
        }
      }
      .details.free ul {
        height: 140px !important;
        li {
          height: 52px !important;
          i {
            margin-right: 10px !important;
          }
          .date-detail {
            width: 70%;
            margin-top: 5px !important;
          }
          .lasttime-1366 {
            // display: none;
          }
          .date-1366 {
            width: 70%;
          }
        }
      }
      .details.fault {
        ul {
          li {
            .date-detail {
              width: 70%;
            }
            .fault-date,.icon-fault {
              margin-right: 10px !important;
            }
          }
        }
      }
      .details.yuyue {
        ul {
          li {
            height: 52px !important;
            i {
              margin-right: 10px !important;
            }
            .date-detail {
              width: 70%;
              margin-top: 5px !important;
            }
          }
        }
      }
      .details.ready {
        ul {
          li {
            height: 52px !important;
            .date-detail {
              margin-top: 5px !important;
            }
          }
        }
      }
    }
    .box-bottom.active {
      height: 300px !important;
      z-index: 100 !important;
      box-shadow:0px 3px 0px rgba(0,0,0,.15) !important;
      -webkit-transition: .3s ;
      -o-transition: .3s ;
      transition: .3s ;
    }
  }
}
@media screen and (max-width:1270px){
  .equipment {
    .equipment-bottom {
      .bottom-content {
        .box-bottom {
          .details  {
            // margin-left: 4%;
          }
        }
      }
    }
  }   
}
@media screen and (min-width:1199px) and (max-width:1501px){
  .equipment {
    .box-top {
      .title {
        span {
          font-size: 14px !important; 
        }
        .issue-number {
          margin-left: 10px !important; 
        }
      }
      .icon {
        margin-right: 10px !important; 
      }
    }
    .equipment-bottom {
      .details {
        ul {
          li {
            i.qty-now {
              margin-right: 10px !important;
            }
            i.chargin-time,i.elce-fee,i.current,i.voltage {
              margin-right: 8px !important;
            }
            i.soc,i.vin {
              margin-right: 10px !important;
            }
            span {
              font-size: 14px;
              margin-right: 5px !important;
            }
          }
        }
      }
      .bottom-content {
        width: 32.33%;
      }
      .bottom-content:nth-child(4n+4) {
        margin-right: 1%;
      }
      .bottom-content:nth-child(3n+3) {
        margin-right: 0;
      }
    }
  }
}
@media screen and (max-width:1198px){
  .equipment {
    .box-top {
      .title {
        span {
          font-size: 14px !important; 
        }
        .issue-number {
          margin-left: 10px !important; 
        }
      }
      .icon {
        margin-right: 10px !important; 
      }
    }
    .equipment-bottom {
      .details {
        ul {
          li {
            i.qty-now {
              margin-right: 10px !important;
            }
            i.chargin-time,i.elce-fee,i.current,i.voltage {
              margin-right: 8px !important;
            }
            i.soc,i.vin {
              margin-right: 10px !important;
            }
            span {
              font-size: 14px;
              margin-right: 5px !important;
            }
          }
        }
      }
      .bottom-content {
        width: 49.1%;
      }
      .bottom-content:nth-child(3n+3) {
        margin-right: 1%;
      }
      .bottom-content:nth-child(2n+2) {
        margin-right: 0;
      }
    }
  }
}
@media screen and (max-width:1020px){
  .equipment {
    .equipment-center {
      a {
        font-size: 14px;
        margin-right: 15px;
      }
    }
  }
}
@media screen and (min-width:1201px) and (max-width:1320px){
.equipment .equipment-bottom .bottom-content .box-bottom .details ul li .data-vin {
  font-size: 10px;
  width: 150px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
}
@media screen and (min-width:1501px) and (max-width:1856px){
.equipment .equipment-bottom .bottom-content .box-bottom .details ul li .data-vin {
  font-size: 10px;
  width: 150px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
}
</style>
<style lang="scss">
.equipment {
  .top-right {
    .el-select {
      ::-webkit-input-placeholder { /* WebKit browsers */
          color:    #58B6EA !important;
      }
      :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
          color:    #58B6EA !important;
      }
      ::-moz-placeholder { /* Mozilla Firefox 19+ */
          color:    #58B6EA !important;
      }
      :-ms-input-placeholder { /* Internet Explorer 10+ */
          color:    #58B6EA !important;
      }
      .el-input__inner {
        border: 1px solid #60C8FF !important;
        background-color: transparent !important; 
        color: #58B6EA !important;
      }
      .el-input {
        .el-select__caret {
          color: #58B6EA !important;
        }
      }
    }
  }
}
.equipment-body .el-select-dropdown {
  border: 1px solid #135A69 !important;
  background-color: #132B39 !important;
  ul {
    li {
      span {
        color:    #58B6EA !important;
      }
    }
    li:hover {
      background-color: #317DD6 !important;
      span {
        color:    #fff !important;
      }
    }
  }
  .popper__arrow {
    display: none !important;
  }
}
.el-popper {
  margin-top:0 !important;
}
.equipment-body .el-select-dropdown__item.hover, .equipment-body .el-select-dropdown__item:hover {
  background-color: #317DD6 !important;
  span {
    color:    #fff !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/realTimeMonitoring/equipmentMonitoring.vue